var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "plan-feature" } }, [
    _c("div", { staticClass: "feature" }, [
      _c("div", { staticClass: "feature-title" }, [_vm._v("Mail Feature")]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "feature-delete",
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_c("span", { staticClass: "material-icons" }, [_vm._v("close")])]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "feature-form" }, [
      _c("div", { staticClass: "feature-item" }, [
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.detailedBroadcastReport,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "detailedBroadcastReport", $$v)
                  },
                  expression: "featureForm.detailedBroadcastReport",
                },
              },
              [_vm._v("Detailed Broadcast Report")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "feature-label" }, [
          _vm._v("First Mail Free Count"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.mailFreeCount,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "mailFreeCount", $$v)
                },
                expression: "featureForm.mailFreeCount",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "feature-label" }, [
          _vm._v("Max Mail Limit (Send/Receving)"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.mailCount,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "mailCount", $$v)
                },
                expression: "featureForm.mailCount",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "feature-label" }, [
          _vm._v("Mail Per Count (1 = 0.00001|5K=1)"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.mailPerCount,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "mailPerCount", $$v)
                },
                expression: "featureForm.mailPerCount",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "feature-label" }, [
          _vm._v("Mail Sayısı Başına Fiyat"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.mailPerPrice,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "mailPerPrice", $$v)
                },
                expression: "featureForm.mailPerPrice",
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }